import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import DownloadOrViewPdf from 'components/DownloadOrViewPdf';
import { formatFileName } from 'utils/func';
import { REGISTER_RESULT_FILE_TYPE } from 'constant';

export default function ProductDescription({ control, handleDownloadFile }) {
  // #region Data
  const { t } = useTranslation();

  const { fields } = useFieldArray({
    control,
    name: 'registerResultStats',
  });

  // #endregion Data
  return (
    <div>
      <div className="text-sm font-bold mb-2">
        {t('r09.form.note')}
        <div>{t('r09.form.note1')}</div>
        <div>{t('r09.form.note2')}</div>
      </div>

      <div className="form-table">
        <table className="mb-2">
          <thead>
            <tr>
              <th className="text-center" style={{ minWidth: 50, width: 50 }}>
                {t('formLayout.numericalOrder')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productName')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productDescription')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productCapacity')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t(
                  'registerResult.registerContent.productDescription.fields.productImplementation'
                )}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productEconomy')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productTransmission')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productDocumentType')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.productAddress')}
              </th>
              <th className="text-center" style={{ minWidth: 220, width: '20%' }}>
                {t('registerResult.registerContent.productDescription.fields.evidence')}
              </th>
            </tr>
          </thead>
          <tbody>
            {fields?.map((item, index) => (
              <tr key={item.id}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">{item?.name ?? ''}</td>
                <td className="text-center">{item?.description ?? ''}</td>
                <td className="text-center">{item?.productionCapacity ?? ''}</td>
                <td className="text-center">{item?.implementationLevel ?? ''}</td>
                <td className="text-center">{item?.economicData ?? ''}</td>
                <td className="text-center">{item?.transferMethod ?? ''}</td>
                <td className="text-center">{item?.documentType ?? ''}</td>
                <td className="text-center">{item?.address ?? ''}</td>
                <td>
                  {!item?.file?.name ? (
                    item?.filename && (
                      <DownloadOrViewPdf
                        opts={{
                          filename: item?.filename,
                          type: REGISTER_RESULT_FILE_TYPE.PRODUCTS,
                        }}
                        fileName={formatFileName(item?.filename)}
                        handleDownloadOrView={handleDownloadFile}
                        showIcon
                      />
                    )
                  ) : (
                    <span>{formatFileName(item?.file?.name)}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

ProductDescription.propTypes = {
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  handleDownloadFile: PropTypes.func,
};

ProductDescription.defaultProps = {
  handleDownloadFile: () => null,
};
